var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.references.length,
          expression: "references.length",
        },
      ],
      staticClass: "attachment-chips",
    },
    _vm._l(_vm.references, function (ref) {
      return _c("div", { key: ref.id, staticClass: "attachment-chips__chip" }, [
        ref.kind === "image" && ref.url
          ? _c("img", {
              staticClass: "attachment-chips__thumb",
              attrs: { src: ref.thumbnail_url || ref.url, alt: ref.name },
            })
          : _c("i", {
              staticClass: "bi attachment-chips__icon",
              class: _vm.chipIcon(ref),
            }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "attachment-chips__name",
            attrs: {
              href: ref.url,
              download: _vm.download ? ref.name : null,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(ref.name))]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }